<template>
  <div class="bill-detail">
    <el-dialog
      title="验收详情"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="700px"
    >
      <template v-if="workLogDataOne.length && [2,4,6].includes(info.auditStatus)">
        <div class="title">
          <span class="title_inside" />
          驳回原因
        </div>
        <el-input
          type="textarea"
          :rows="6"
          readonly
          v-model="workLogDataOne[0].auditNote"
          style="margin-bottom: 24px"
        />
      </template>
      <div class="title">
        <span class="title_inside" />
        招生销售验收信息
      </div>
      <div v-loading="loading" class="content">
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">验收订单编号：</p>
          <p class="value">{{ info.id }}</p>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">招生方名称：</p>
          <p v-if="info.isAgentFlag === 1" class="value">教务服务方 - {{ info.agentName }}</p>
          <p v-else-if="info.isAgentFlag === 2" class="value">招生服务方 - {{ info.distributionName }}</p>
          <p v-else class="value"> -- </p>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">申请人：</p>
          <p class="value">{{ info.applyUserName }}</p>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">申请时间：</p>
          <p class="value">{{ info.applyDate }}</p>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">本次应验收总人次：</p>
          <p class="value">{{ info.orderNum }}</p>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">验收结算标准：</p>
          <p class="value">{{ info.checkAcceptStandard }}元/人次</p>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">本次实际退回保证金：</p>
          <p class="value">{{ info.returnBond }}元</p>
        </el-row>
      </div>

      <div class="title">
        <span class="title_inside" />
        审批流程
      </div>
      <template v-if="!workLogBool">
        <el-timeline  v-loading="loading">
          <el-timeline-item
            v-for="(activity, index) in workLogDataOne"
            :key="index"
            icon="el-icon-more"
            color="#4795f5"
            type="primary"
            size="large"
            :timestamp="activity.auditDate"
          >
            <div style="word-break: break-all">
              【{{ activity.companyName }}】
              <span style="margin-right: 16px">{{ activity.remarks }}<span v-if="![1,3,5].includes(activity.auditStatus)">, {{ activity.auditorName }}</span></span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
      <template v-else>
        <el-timeline  v-loading="loading">
          <el-timeline-item
            v-for="(activity, index) in workLogData"
            :key="index"
            :icon="index === 0 ? 'el-icon-more' : ''"
            :color="index === 0 ? '#4795f5' : ''"
            type="primary"
            size="large"
            :timestamp="activity.auditDate"
          >
            <div style="word-break: break-all">
              【{{ activity.companyName }}】
              <span style="margin-right: 16px">{{ activity.remarks }}<span v-if="![1,3,5].includes(activity.auditStatus)">, {{ activity.auditorName }}</span></span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
      <div
        v-if="workLogData.length > 1"
        class="show_box"
        @click="workLogBool = !workLogBool"
      >
        {{ workLogBool ? "收起" : "展开" }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loading" size="small" @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCheckAcceptByOrderByOrderId
} from "@/api/orderAdmin/orderList"

export default {
  name: 'BillDetail',

  data () {
    return {
      dialogVisible: false,
      loading: false,
      info: {},
      workLogData: [],
      workLogDataOne: [],
      workLogBool: false
    }
  },
  methods: {
    init (id) {
      this.handleGetDetail(id)
      this.dialogVisible = true
    },
    handleGetDetail (orderId) {
      this.loading = true
      let params = { orderId }
      getCheckAcceptByOrderByOrderId(params).then(({ code, data }) => {
        if (code === 0 && data) {
          this.info = data
          if (data.audits) {
            this.workLogData = data.audits
            if (data.audits.length > 0) {
              this.workLogDataOne = [data.audits[0]]
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleClose () {
      this.info = {}
      this.workLogData = []
      this.workLogDataOne = []
      this.workLogBool = false
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.bill-detail {
  ::v-deep .el-dialog__body {
    padding: 16px 40px 30px 30px;
  }
  .title {
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 22px;
    margin-left: 2px;
    color: #333;
    .title_inside {
      display: inline-block;
      width: 4px;
      height: 18px;
      background: #4795f5;
      margin-right: 6px;
    }
  }
  .show_box {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    padding: 8px 0;
    font-size: 14px;
    margin-bottom: 30px;
    background-color: #ffffff;
  }
  .show_box:hover {
    background-color: #f9fafc;
  }
}
.content {
  margin-bottom: 24px;
}
.content-line {
  padding: 8px 0;
  font-size: 14px;
  color: #333;
  .label {
    width: 160px;
    text-align: right;
  }
  .value {
    margin-left: auto;
  }
}
</style>
